import React from "react";
import { Button, Container } from "@material-ui/core";
import "./InvestorTabBlocks.css";
import IAABlock from "../InvestorBlockComponent/IAABlock";
import IAMBlock from "../InvestorBlockComponent/IAMBlock";
import DairyBlock from "../InvestorBlockComponent/DairyBlock";
import EssentialOils from "../InvestorBlockComponent/EssentialOils";
import IAAProducer from "../InvestorBlockComponent/IAAProducer";
import IAMProducer from "../InvestorBlockComponent/IAMProducers";
export default function InvestorTabBlocks({title,description, buttonText, href,src,src2,IAA,IAM,IAAP,IAMP,network,producers,DB,EssentailOils}) {
  return (
    <Container className="custom-container abn-container">
      <h4 className="container-title mx-4"> {title}</h4>
      <p className="container-para mb-3">
        {description}
      </p>
      {IAA && <IAABlock producers={producers}/>}
      {IAAP && <IAAProducer producers={producers}/>}
      {IAM && <IAMBlock producers={producers}/> }
      {IAMP && <IAMProducer producers={producers}/> }

      {DB && <DairyBlock producers={producers}/>}
      {EssentailOils && <EssentialOils producers={producers}/>}


      {src && <img className={`${network ? "networkImg d-block mx-auto" :"mob-vis"} `}src={src} alt="ABN-Image" />}
      {src2 && <img className="mob-hide"  src={src2} alt="ABN-Image" />}

      {href  && <Button variant="contained" color="primary" >
        <a href={href}>{buttonText} </a>
      </Button>}
    </Container>
  );
}
